import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ViItemComponent } from '@vi-iot/ui';

import { UnitsStore } from '@store';

import {
  generateTemperatureValues,
  getOutOfRangeValue,
  SelectTemperatureValue,
  TemperatureRangeDefinition,
} from '../../converter/converter';
import { Unit } from '../../../../shared/common/units';

@Component({
  selector: 'app-temperature-select',
  templateUrl: './temperature-select.component.html',
  styleUrls: ['./temperature-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemperatureSelectComponent implements OnChanges, OnDestroy {
  Unit = Unit;
  options: SelectTemperatureValue[] = [];
  isCelsius: boolean;
  outOfRangeValue?: number;

  private _value: any;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  @Input() isTile: boolean;

  @Input() title: string;

  @Input()
  set value(value: number) {
    this._value = value;
    this.itemRef.value = value;
    this.itemRef.currentOptionValue = value;
    this.cdr.markForCheck();
  }
  get value(): number {
    return this._value;
  }

  @Input()
  rangeDefinition: TemperatureRangeDefinition;

  @Output()
  valueChange: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild('itemRef', { static: true })
  itemRef: ViItemComponent;

  constructor(private cdr: ChangeDetectorRef, private unitStore: UnitsStore) {
    this.unitStore.isTemperatureMetric$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((isCelsius) => (this.isCelsius = isCelsius));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.rangeDefinition?.currentValue !== changes.rangeDefinition?.previousValue) {
      this.outOfRangeValue = getOutOfRangeValue(this.rangeDefinition, this.value);
      this.options = generateTemperatureValues(
        this.rangeDefinition,
        this.isCelsius,
        this.outOfRangeValue
      );
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  onItemValueChange(value: number): void {
    this.valueChange.emit(value);
  }
}
